import { render, staticRenderFns } from "./CustomerImportFileUploader.vue?vue&type=template&id=4e71b08c&scoped=true"
import script from "./CustomerImportFileUploader.vue?vue&type=script&lang=js"
export * from "./CustomerImportFileUploader.vue?vue&type=script&lang=js"
import style0 from "./CustomerImportFileUploader.vue?vue&type=style&index=0&id=4e71b08c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e71b08c",
  null
  
)

export default component.exports